module.exports = __webpack_public_path__ + "static/img/bg_dkjj_white_a.54193906.png";